/**
 * 상점/벌점(개인별)
 */
import React, { Component } from 'react';
import { Form, InputGroup, Navbar, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowCircleLeft, faAngleUp, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { udfSetRuleHistorySearchKeyword, ruleHistorySearchKeyword, ruleHistory_relod, udfSetRuleHistoryReload, udfSetStdtRuleReload } from '../../common/usr/stdtList';
import { dropByCacheKey } from 'react-router-cache-route'

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 15;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;
let firstTime = true;

let that = this;

class RuleHistoryCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      stdtList: [],
      searchKeyword: ruleHistorySearchKeyword,
      usrInfo: null,
    }

    props.cacheLifecycles.didCache(this.componentDidCache)
    props.cacheLifecycles.didRecover(this.componentDidRecover)
  }

  // 스크롤 위치 기억
  scrollPostion = 0;

  // 본 페이지를 떠날때 캐시 저장후 이벤트
  componentDidCache = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');

    // 스크롤 이벤트 해제
    window.removeEventListener('scroll', this.handleScroll);
  }

  // 케시된 페이지로 바로 다시 돌아 왔을때 캐시 내용 복원 후 이벤트
  componentDidRecover = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 바인딩
    window.addEventListener('scroll', this.handleScroll);

    console.log("componentDidRecover", ruleHistory_relod);
    firstTime = true;
    if (ruleHistory_relod) {
      // 검색어가 없는 경우, 목록 초기화
      if (ruleHistorySearchKeyword === '') {
        firstIndex = 0;	// 불러 올 시작 레코드
        isMore = true;	// 불러 올 레코드 존재 여부
        isRunning = false;

        $('#searchKeyword').focus();

        this.setState({
          stdtList: [],
          searchKeyword: ruleHistorySearchKeyword
        });
      } else this.udfSelectStdtList('Y');
    } else {
      // 스크롤 위치 복원
      $(window).scrollTop(this.scrollPostion);
    }
  }

  componentDidMount = () => {
    firstTime = true;

    console.log("componentDidMount", isMore, !isRunning, !isLogging);
    if (!isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        console.log(data);
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          isLogging = false;
          this.setState({ usrInfo: data });
          if (this.state.searchKeyword !== '') this.udfSelectStdtList('Y');
          else $('#searchKeyword').focus();
        } else {
          this.props.history.push('/');
        }
      });
    }

    if (this.state.stdtList.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
    }

    window.addEventListener('scroll', this.handleScroll);

    if (this.state.searchKeyword !== '') this.udfSelectStdtList('Y');
    else $('#searchKeyword').focus();
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // 스크롤 위치 기억
    this.scrollPostion = $(window).scrollTop();

    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectStdtList('N');
    }
  }

  udfSelectStdtList = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;
    firstTime = false;

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
      udfSetStdtRuleReload(true);
    }

    that = this;
    if (isMore && !isRunning && this.state.searchKeyword !== '') {
      udfInlineLoading();
      isRunning = true;

      let setData = {
        isMobile: 'Y',
        firstIndex: firstIndex,
        recordCountPerPage: recordCountPerPage,
        searchKeyword: this.state.searchKeyword,
        isAll: 'Y',
      };

      // 초기화
      udfSetRuleHistorySearchKeyword(this.state.searchKeyword);

      $.ajax({
        url: url + '/sli/stdt/selectStdtList.do',
        type: 'GET',
        dataType: 'jsonp',
        data: setData,
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let stdtList = [];
            if (data.list !== undefined && data.list !== null) {
              var idx = firstIndex;
              $.each(data.list, function (i, val) {
                idx++;

                stdtList.push({
                  STD_CD: val.STD_CD,
                  HAKGWA: val.HAKGWA,
                  GRADE: val.GRADE,
                  BAN: val.BAN,
                  BUN: val.BUN,
                  STD_NM: val.STD_NM
                });
              });

              // 1명인 경우, 상벌점 조회로 이동
              if (data.list.length === 1) {
                udfSetRuleHistorySearchKeyword('');
                that.props.history.push(`/usr/stdtRuleHistory/${stdtList[0].STD_CD}`);
              }

              if (idx - firstIndex !== recordCountPerPage) isMore = false;
              firstIndex += recordCountPerPage;

              if (clearYn !== 'Y') stdtList = that.state.stdtList.concat(stdtList);

              that.setState({
                stdtList: stdtList
              });
            }
          }
          isRunning = false;
          udfSetRuleHistoryReload(false);
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  render() {
    let setStdtList = this.state.stdtList.map((data, idx) => {
      let linkUrl = '/usr/stdtRuleHistory/' + data.STD_CD;
      return (
        <Link to={linkUrl} key={idx}>
          <ListGroup.Item>
            {data.HAKGWA}{data.HAKGWA !== undefined ? ' ' + data.GRADE : data.GRADE}학년 {data.BAN}반 {data.BUN}번 {data.STD_NM}
            <span style={{ float: 'right' }}><FontAwesomeIcon icon={faChevronRight} /></span>
          </ListGroup.Item>
        </Link>
      );
    });

    return (
      <>
        {/* to the top */}
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : '벌점'} (개인별)
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <Form style={{ marginTop: '62px' }}>
          <InputGroup style={{ padding: '0.75rem 15px' }}>
            <Form.Control
              className="form-control-lg"
              type='text'
              id='searchKeyword'
              placeholder='검색(학번 / 이름)'
              value={this.state.searchKeyword}
              onChange={(e) => this.setState({ searchKeyword: e.target.value })}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  if (this.state.searchKeyword === '') {
                    openAlert(this, '검색어를 입력해주세요.');
                  } else {
                    $(e.target).blur();
                    this.udfSelectStdtList('Y');
                  }

                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            />
            <InputGroup.Append
              onClick={() => {
                if (this.state.searchKeyword === '') {
                  openAlert(this, '검색어를 입력해주세요.');
                } else this.udfSelectStdtList('Y');
              }}
            >
              <InputGroup.Text
                id="searchKeywordLabel"
                style={{ fontSize: '1.5rem' }}
                className="pl-4 pr-4"
              >
                <FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
            </InputGroup.Append>
          </InputGroup>
          {
            this.state.stdtList.length === 0 && !firstTime ?
              <p className="text-center text-danger">
                "{this.state.searchKeyword}" 찾고자 하는 데이터가 없습니다.
              </p>
              : ''
          }
          <p className="text-center">
            학번 5자리 (학년1자리+반2자리+번호2자리)<br /> 또는 학생이름으로 검색해 주세요.
            <br />
            (예: 1학년 2반 15번 검색시 10215 입력)
          </p>
        </Form>

        <ListGroup variant='flush' style={{ marginBottom: '4rem' }}>
          {setStdtList}
        </ListGroup>

      </>
    );
  }
}

export default RuleHistoryCmp;